// 2026-06-25: Process Master edit dialog
import { useState, useEffect } from 'react';
import { Dialog, DialogTitle, TextField, Button, IconButton, Tooltip } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import Swal from 'sweetalert2';
import { shiftadd } from '../../Services/app/masterservice';

const PRESET_COLORS = ['#2563eb', '#16a34a', '#f59e0b', '#dc2626', '#9333ea', '#6b7280', '#f97316', '#0891b2', '#ec4899'];

export default function ProcessMasterEdit({ open, handleClose, handleEdit, dialogOpenCount, datasource, customerId, editData }) {
  const dialogBackgroundColor = dialogOpenCount === 0 ? '#f7f7f7' : '#ededed';
  const [form, setForm] = useState({
    code: '', name: '', color: '#2563eb', workflow_order: 1, description: '', active: true,
  });

  useEffect(() => {
    if (editData) setForm({ ...editData });
  }, [editData]);

  const onSubmit = async () => {
    if (!form.name.trim()) { Swal.fire('Missing field', 'Name is required', 'warning'); return; }
    try {
      const updated = (datasource || []).map(p => p.id === editData.id ? {
        ...form,
        workflow_order: Number(form.workflow_order) || 1,
        updated_at: Date.now(),
      } : p);
      await shiftadd({ process_master: updated }, customerId, 'SERVER_SCOPE');
      Swal.fire({ icon: 'success', title: 'Process updated', timer: 1100, showConfirmButton: false });
      handleEdit();
    } catch (e) {
      Swal.fire('Error', e?.response?.data?.message || e.message || 'Save failed', 'error');
    }
  };

  return (
    <Dialog open={open} onClose={handleClose} fullWidth maxWidth="sm" PaperProps={{ style: { background: dialogBackgroundColor } }}>
      <DialogTitle style={{ paddingBottom: 0 }}>
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          <span>Edit Process — {editData?.code}</span>
          <Tooltip title="Close"><IconButton onClick={handleClose}><CloseIcon /></IconButton></Tooltip>
        </div>
      </DialogTitle>
      <div style={{ padding: '12px 24px 24px', display: 'flex', flexDirection: 'column', gap: 14 }}>
        <TextField size="small" label="Code" value={form.code} disabled
                    helperText="Code is locked once set (to preserve references in Machine Groups)"
                    fullWidth />
        <TextField size="small" label="Display Name *" value={form.name}
                    onChange={e => setForm({ ...form, name: e.target.value })} fullWidth />
        <div>
          <label style={{ fontSize: 12, fontWeight: 700, color: '#374151', display: 'block', marginBottom: 6 }}>Brand Color</label>
          <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap' }}>
            {PRESET_COLORS.map(c => (
              <button key={c} type="button" onClick={() => setForm({ ...form, color: c })}
                      style={{ width: 32, height: 32, borderRadius: '50%', background: c,
                                border: form.color === c ? '3px solid #111827' : '1px solid #d1d5db',
                                cursor: 'pointer' }} />
            ))}
            <input type="color" value={form.color || '#2563eb'} onChange={e => setForm({ ...form, color: e.target.value })}
                   style={{ width: 32, height: 32, borderRadius: '50%', border: '1px solid #d1d5db', cursor: 'pointer' }} />
          </div>
        </div>
        <TextField size="small" label="Workflow order" type="number" value={form.workflow_order}
                    onChange={e => setForm({ ...form, workflow_order: e.target.value })} fullWidth />
        <TextField size="small" label="Description" value={form.description || ''}
                    onChange={e => setForm({ ...form, description: e.target.value })}
                    multiline rows={2} fullWidth />
        <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 8 }}>
          <Button onClick={handleClose} variant="outlined" color="inherit">Cancel</Button>
          <Button onClick={onSubmit} variant="contained" style={{ background: '#f97316' }}>Save Changes</Button>
        </div>
      </div>
    </Dialog>
  );
}
